module.exports = __webpack_public_path__ + "static/img/lunpan.6e810da1.png";